import customer from "./modules/customer";

export default {
    modules: {
        customer
    }
}
